import React, { useState } from "react";
import ArrowsOut from './../../../../assets/images/ArrowsOut.svg';
import styles from './dispatchPriority.module.css';
import StackedBarChart from "Samarth Module/components/Charts/StackedBarChart";
import ExpandedModal from "Samarth Module/components/modal/ExpandedModal";

export default function MinMaxDispatches({ label, data, sideTabVal }) {
    const [expandedView, setExpandedView] = useState(false);

    // Handler for expanding the graph
    const handleExpand = () => {
        setExpandedView(prev => !prev);
    }

    const recordsCount = data?.length || 0;
    const barHeight = 25;
    const chartHeight = recordsCount * barHeight + 100;
    const maxContainerHeight = 450;
    const minChartWidth = 800;
    
    // Add buffer to prevent unnecessary scrollbar for small datasets
    const shouldScroll = chartHeight > (maxContainerHeight + 20);

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <p className={styles.title}>{label}</p>
                <div className={styles.arrows_out}>
                    <img src={ArrowsOut} alt='Stacked bar chart' height={16} width={16} onClick={handleExpand}/>
                </div>
            </div>
            <div style={{
                position: 'relative',
                maxHeight: shouldScroll ? maxContainerHeight : 'none',
                overflowY: shouldScroll ? 'auto' : 'visible',
                overflowX: 'hidden',
                width: '100%',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
                padding: '10px',
                paddingBottom: '0px', // Space for sticky x-axis
                boxSizing: 'border-box'
            }}>
                <div style={{ 
                    width: '100%',
                    position: 'relative'
                }}>
                    <StackedBarChart 
                        graphData={data} 
                        chartHeight={chartHeight} 
                        maxContainerHeight={maxContainerHeight}
                        stickyXAxis={true}
                        sideTabVal={sideTabVal}
                    />
                </div>
            </div>
            {expandedView && (
                <ExpandedModal onClose={handleExpand} open={expandedView} >
                    <div className={styles.modalContainer}>
                        <p className={styles.title} style={{ marginBottom: '2rem' }}>{label}</p>
                        <div className={styles.chartContainer}>
                            <div style={{ minWidth: minChartWidth }}>
                                <StackedBarChart 
                                    graphData={data} 
                                    chartHeight={chartHeight} 
                                    maxContainerHeight={maxContainerHeight}
                                    stickyXAxis={true}
                                    sideTabVal={sideTabVal}
                                />
                            </div>
                        </div>
                    </div>
                </ExpandedModal>
            )}
        </>
    );
}